import { mapActions } from 'vuex';
import { FORM_TYPE_IDV, FORM_TYPE_TRIGGERS } from '@/constants';
import accountVerifyMixin from '@/mixins/accountVerify';
import { MODALS } from '@/components/app/app-modals/app-modals'


export default {
  mixins: [
    accountVerifyMixin,
  ],
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: '',
    },
  },
  computed: {
    classModifiers() {
      return {
        'account-ssn-info-upload': true,
        'account-ssn-info-upload--modal': this.isPopup,
        'account-ssn-info-upload--embedded': !this.isPopup,
        [`account-ssn-info-upload--${this.theme}`]: this.theme,
      };
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopupOptions', 'setCurrentPopup']),
    onButtonClick() {
      const trigger = this.isPopup ? FORM_TYPE_TRIGGERS.MODAL : FORM_TYPE_TRIGGERS.STANDALONE;
      const options = { formType: FORM_TYPE_IDV.SSN4IDV, trigger };
      this.setCurrentPopup(MODALS.ACCOUNT_VERIFY);
      this.setCurrentPopupOptions(options);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-ssn-info-upload/account-ssn-info-upload.js